import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "mt-2 p-5 border-[4px] border-gray-200 border-dashed text-center font-medium text-gray-400" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString($props.title || 'There has been an error. Please try again.'), 1 /* TEXT */));
}
